import React from 'react';
import styled from '@emotion/styled';
import { tokens } from '../../../public/tokens';
import { Heading3 } from './Typography';

const { typography, globals } = tokens;

const HeaderWrap = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${globals['spacing-sm']};
    margin-bottom: ${globals['spacing-lg']};

    ${({ $divider }) =>
        $divider &&
        `border-bottom: 1px solid var(--surfaces-border-divider);
     padding-bottom: ${globals['spacing-sm']};`}

    .text-md-right p {
        margin: 0;
    }

    .text-md-right.action2-blk {
        margin-left: 20px;
        padding-left: 20px;
        border-left: 1px solid var(--surfaces-border-divider);
    }

    @media (max-width: 767px) {
        flex-direction: column;
        align-items: flex-start;

        .text-md-right.action2-blk {
            margin-left: 0;
            padding-left: 0;
            border-left: none;
        }
    }
`;

const Title = styled(Heading3)`
    color: var(--text-primary);
    margin: 0;
    font-weight: ${typography.fontWeights.bold};
    line-height: ${typography.lineHeights['130']};

    span {
        color: var(--topbar-color);
    }
`;

const RightSlot = styled('div')`
    text-align: right;

    p {
        margin: 0;
    }
`;

// Standard page header: title left, optional right-hand slot, consistent bottom spacing.
// Use `children` for non-standard content (e.g. ticket view's grouped heading + actions).
const PageHeader = ({ title, right, className = '', divider = false, children }) => {
    return (
        <HeaderWrap className={className} $divider={divider}>
            {title !== undefined && <Title>{title}</Title>}
            {children}
            {right !== undefined && <RightSlot>{right}</RightSlot>}
        </HeaderWrap>
    );
};

export default PageHeader;
